import { render, staticRenderFns } from "./ChangePaymentEndDate.vue?vue&type=template&id=b2b47a58&"
import script from "./ChangePaymentEndDate.vue?vue&type=script&lang=js&"
export * from "./ChangePaymentEndDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports